import { useEffect, useState } from "react";
import { getIsOnline, subscribeConnectivity } from "@/lib/connectivity";

/**
 * Hook to subscribe to real connectivity state (heartbeat-based).
 * Replaces the legacy `navigator.onLine` + `window.addEventListener('online'/'offline')` pattern.
 */
export function useConnectivity() {
  const [isOnline, setIsOnline] = useState<boolean>(() => getIsOnline());

  useEffect(() => {
    // Re-sync on mount in case the initial heartbeat already ran
    setIsOnline(getIsOnline());
    return subscribeConnectivity(setIsOnline);
  }, []);

  return { isOnline };
}